import axios from "axios";

const getAuthToken = () => "Bearer " + localStorage.getItem("token");

const getHeaders = () => ({
    Authorization: getAuthToken(),
    "Accept-Language": localStorage.getItem("lang")?.toLowerCase() ?? "ru",
});

const HOST_MODE = {
    PROD_PAYMENT: "https://pay.tvcom.uz",
    DEV_PAYMENT: "https://pay.tvcom.uz",
    // DEV_PAYMENT: "https://dev.cp.tvcom.uz/",
    HISTORY: "https://api.tvcom.uz/",
};

const HOST =
    process.env.MIX_NODE_ENV === "development"
        ? HOST_MODE.DEV_PAYMENT
        : HOST_MODE.PROD_PAYMENT;

// API config
const API = {
    PAYMENT: `${HOST}/api/V1/`,
    HISTORY: HOST_MODE.HISTORY,
};

const PAYMENT_API = axios.create({
    baseURL: API.PAYMENT,
});

const PAYMENT_HISTORY_API = axios.create({
    baseURL: API.HISTORY,
});

// --//-- API config

// Получить сохраненные банк. карты
const getSavedCards = async () => {
    try {
        const { data } = await PAYMENT_API.get(`atmos/cards`, {
            headers: getHeaders(),
        });

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

//
const getOrder = async (orderId) => {
    try {
        const { data } = await PAYMENT_API.get(`atmos/orders/${orderId}`, {
            headers: getHeaders(),
        });

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

//
const initTransaction = async ({ order_id, card_number, card_expiry }) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/orders/${order_id}/init`,
            {
                card_number,
                card_expiry,
            },
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

//
const confirmTransaction = async (params) => {
    const { order_id, card_bind_transaction_id, sms_code } = params;

    try {
        const { data } = await PAYMENT_API.post(
            `atmos/orders/${order_id}/confirm`,
            {
                card_bind_transaction_id,
                sms_code,
            },
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Пополнение баланса через виджет
const topUpBalanceViaWidget = async (amount) => {
    try {
        const { data } = await PAYMENT_API.post(
            "atmos/orders",
            {
                amount,
            },
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Пополнение баланса через карту
const topUpBalanceViaCard = async ({ amount, card_id }) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/balance/fill`,
            {
                card_id,
                amount,
            },
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Выбрать основную карту
const setMainCard = async ({ card_id }) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/cards/${card_id}/set_main
            `,
            {},
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Удалить банк. карту
const deleteCard = async (card_id) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/cards/${card_id}/delete`,
            {},
            {
                headers: getHeaders(),
            }
        );
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Активировать тариф сохраненной картой
const activateTariffBySavedCard = async ({ tariff_id, card_id }) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/tariffs/${tariff_id}/activate`,
            {
                card_id,
            },
            {
                headers: getHeaders(),
            }
        );
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Активировать тариф новой картой
const activateTariffByNewCard = async (tariff_id) => {
    try {
        const { data } = await PAYMENT_API.post(
            `atmos/orders`,
            { tariff_id },
            {
                headers: getHeaders(),
            }
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// История платежй
const getPaymentHistory = async () => {
    try {
        const { data } = await PAYMENT_HISTORY_API.get(
            "/api/v1.2.0/payments/history",
            {
                headers: getHeaders(),
            }
        );
        return data;
    } catch (error) {
        return error;
    }
};

const customerSync = async () => {
    try {
        const res = await PAYMENT_API.post(
            "atmos/customer/sync",
            {},
            {
                headers: {
                    Authorization: getAuthToken(),
                },
            }
        );

        return res;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export default {
    getOrder,
    initTransaction,
    confirmTransaction,
    activateTariffBySavedCard,
    setMainCard,
    getSavedCards,
    topUpBalanceViaWidget,
    topUpBalanceViaCard,
    deleteCard,
    getPaymentHistory,
    activateTariffByNewCard,
    customerSync,
};
